import { useContext } from 'react';
import { ContextType as DiscountContext } from '~/context/common/DiscountContext';
import { ContextType as TradeContext } from '~/context/common/TradeContext';
import { useIsLoggedIn } from '~/context/common/UserContext';

export default function useIsPriceLoading(
  discountContext: React.Context<DiscountContext>,
  tradeContext: React.Context<TradeContext>
) {
  const { discounts } = useContext(discountContext);
  const { trades } = useContext(tradeContext);
  const isLoggedIn = useIsLoggedIn();

  return !discounts.isLoaded || (isLoggedIn && !trades.isLoaded);
}
